var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6664 0.929688H5.48538V2.65669H10.6654L10.6664 0.929688ZM7.21238 12.1537H8.93938V6.97369H7.21238V12.1537ZM14.1454 6.44669L15.3714 5.22069C15.0032 4.77918 14.5959 4.37185 14.1544 4.00369L12.9284 5.22969C11.3771 3.98946 9.40972 3.39038 7.43047 3.55551C5.45121 3.72063 3.61033 4.63743 2.28598 6.11756C0.961625 7.5977 0.254353 9.52879 0.309451 11.5142C0.364549 13.4995 1.17783 15.3884 2.58224 16.7928C3.98665 18.1972 5.87554 19.0105 7.86091 19.0656C9.84628 19.1207 11.7774 18.4134 13.2575 17.0891C14.7376 15.7647 15.6544 13.9239 15.8196 11.9446C15.9847 9.96534 15.3856 7.998 14.1454 6.44669ZM8.07638 17.3297C6.88099 17.3297 5.71244 16.9752 4.71851 16.3111C3.72458 15.647 2.94991 14.703 2.49245 13.5986C2.035 12.4942 1.9153 11.279 2.14851 10.1066C2.38172 8.93414 2.95736 7.8572 3.80263 7.01193C4.64789 6.16667 5.72483 5.59103 6.89725 5.35782C8.06968 5.12461 9.28492 5.2443 10.3893 5.70176C11.4937 6.15922 12.4377 6.93389 13.1018 7.92782C13.7659 8.92175 14.1204 10.0903 14.1204 11.2857C14.121 12.0796 13.9652 12.8658 13.6616 13.5994C13.3581 14.333 12.913 14.9995 12.3516 15.5609C11.7902 16.1223 11.1237 16.5674 10.3901 16.871C9.65651 17.1745 8.87027 17.3303 8.07638 17.3297Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.8f2094b6a110533d33fa10fa053a1045.svg";
export { ForwardRef as ReactComponent };